import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=01dccb2c&scoped=true"
import script from "./Bank.vue?vue&type=script&lang=ts"
export * from "./Bank.vue?vue&type=script&lang=ts"
import style0 from "./Bank.vue?vue&type=style&index=0&id=01dccb2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dccb2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01dccb2c')) {
      api.createRecord('01dccb2c', component.options)
    } else {
      api.reload('01dccb2c', component.options)
    }
    module.hot.accept("./Bank.vue?vue&type=template&id=01dccb2c&scoped=true", function () {
      api.rerender('01dccb2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Bank.vue"
export default component.exports